export enum AppSwitch {
  MAINTENANCE = 'MAINTENANCE',
  CONNECT_IOS_CLEAR_ANNOTATIONS = 'CONNECT_IOS_CLEAR_ANNOTATIONS',
  CRONOFY_EVENT = 'CRONOFY_EVENT',
  GOOGLE_SIGNIN_ONLY = 'GOOGLE_SIGNIN_ONLY',
  REPORT_EMBEDS = 'REPORT_EMBEDS',
}

export type Switch = {
  active: boolean
  created: string
  id: number
  modified: string
  name: string
  note: string
}
